export const areQuantitiesEqual = (a: Record<string, number>, b: Record<string, number>): boolean => {
  const keys = new Set([...Object.keys(a), ...Object.keys(b)])

  for (const key of keys) {
    if ((a[key] ?? 0) !== (b[key] ?? 0)) return false
  }

  return true
}
